var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMenuBl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 225"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 272",
    width: 18,
    height: 2,
    rx: 1,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 273",
    y: 7,
    width: 18,
    height: 2,
    rx: 1,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 274",
    y: 14.0002,
    width: 18,
    height: 2,
    rx: 1,
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuBl);
export default __webpack_public_path__ + "static/media/ic_menu_bl.9fc6f27ac00f1ce046cfd3bc22f9735e.svg";
export { ForwardRef as ReactComponent };